"use client";

/* ————— fol. 3v — Manifesto —————
   The page's one full-light moment: a full-bleed vellum spread. The
   darkness parts and you're looking at pure page. Uses .reading to
   flip every token to the warm-paper palette (rubric → gold-deep,
   foreground → iron-gall, background → vellum) for free, plus the
   vellum-2000.webp texture as a low-opacity overlay. Soft gradient
   edges (Jay-approved — keep) hand off to/from the ink sections.

   Motion: scroll-scrubbed (Jay direction 2026-07-10). The vellum
   surface arrives with scroll; the statement reads itself in with the
   app's WordStream per-word cascade, also scrubbed.
*/

import { Scrub, ScrubWords } from "./Scrub";

export default function Manifesto() {
  return (
    <section data-folio="fol. 3v" data-folio-title="Why Sola exists" className="relative">
      <Scrub from="up" start="top 96%" end="top 65%">
        <div className="reading relative overflow-hidden">
          {/* Vellum grain */}
          <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage: "url(/atmosphere/vellum-2000.webp)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.4,
              mixBlendMode: "multiply",
            }}
          />
          {/* Soft ink→vellum handoff, top and bottom — never a hard border */}
          <div
            aria-hidden="true"
            className="absolute inset-x-0 top-0 h-28 sm:h-40 pointer-events-none"
            style={{ background: "linear-gradient(to bottom, #0d0b08 0%, rgba(13,11,8,0.55) 35%, rgba(13,11,8,0) 100%)" }}
          />
          <div
            aria-hidden="true"
            className="absolute inset-x-0 bottom-0 h-28 sm:h-40 pointer-events-none"
            style={{ background: "linear-gradient(to top, #0d0b08 0%, rgba(13,11,8,0.55) 35%, rgba(13,11,8,0) 100%)" }}
          />

          <div className="container relative z-10 py-32 sm:py-44 flex flex-col items-center text-center">
            <p className="rubric mb-9">Why Sola exists</p>

            <div aria-hidden="true" className="h-px w-14 mb-12" style={{ background: "var(--gold-deep)" }} />

            {/* Drop cap floats — needs left-aligned wrapping text. The
                statement reads itself in word by word with scroll. */}
            <ScrubWords
              className="dropcap font-scripture max-w-[34ch] text-left"
              style={{ fontSize: "clamp(1.6rem, 1.15rem + 2.1vw, 2.6rem)", lineHeight: 1.42 }}
              start="top 80%"
              end="top 30%"
              text="The Bible doesn’t need an app to be true. Sola exists for the moment a word stops you and you want to know why, without a seminary degree, and without leaving the text."
            />

            <Scrub from="none" start="top 95%" end="top 75%" className="mt-12">
              <span aria-hidden="true" className="block text-lg" style={{ color: "var(--gold-deep)" }}>
                ✦
              </span>
            </Scrub>

            <div aria-hidden="true" className="h-px w-14 mt-12" style={{ background: "var(--gold-deep)" }} />
          </div>
        </div>
      </Scrub>
    </section>
  );
}
